import { normalizeSearchText, searchTerms } from '@helpers/search';

export const searchOptions = (options, query) => {
    const terms = searchTerms(query);
    if (!terms.length) return options;
    return options.filter(option => {
        const text = normalizeSearchText([option.label, option.group].join(' '));
        return terms.every(term => text.includes(term));
    });
};
